// Patch toLocaleDateString / toLocaleString when called without locale options
// so legacy code respects admin Regional Settings (time format).

import * as regionalFormat from '../utils/regionalFormat';

(function patchToLocaleDateString() {
  if (typeof Date === "undefined") return;

  function getFormatters() {
    return regionalFormat;
  }

  const ORIGINAL_DATE = Date.prototype.toLocaleDateString;
  if (ORIGINAL_DATE && !ORIGINAL_DATE.__patchedForRegional) {
    function patched() {
      if (arguments.length > 0) return ORIGINAL_DATE.apply(this, arguments);
      const fmt = getFormatters();
      if (fmt) return fmt.formatDate(this);
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(this.getDate())}/${pad(this.getMonth() + 1)}/${this.getFullYear()}`;
    }
    patched.__patchedForRegional = true;
    Date.prototype.toLocaleDateString = patched;
  }

  const ORIGINAL_LOCALE = Date.prototype.toLocaleString;
  if (ORIGINAL_LOCALE && !ORIGINAL_LOCALE.__patchedForRegional) {
    function patched() {
      if (arguments.length > 0) return ORIGINAL_LOCALE.apply(this, arguments);
      const fmt = getFormatters();
      if (fmt) return fmt.formatDateTime(this);
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(this.getDate())}/${pad(this.getMonth() + 1)}/${this.getFullYear()} ${pad(this.getHours())}:${pad(this.getMinutes())}`;
    }
    patched.__patchedForRegional = true;
    Date.prototype.toLocaleString = patched;
  }

  const ORIGINAL_TIME = Date.prototype.toLocaleTimeString;
  if (ORIGINAL_TIME && !ORIGINAL_TIME.__patchedForRegional) {
    function patched() {
      if (arguments.length > 0) return ORIGINAL_TIME.apply(this, arguments);
      const fmt = getFormatters();
      if (fmt) return fmt.formatTime(this);
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(this.getHours())}:${pad(this.getMinutes())}`;
    }
    patched.__patchedForRegional = true;
    Date.prototype.toLocaleTimeString = patched;
  }
})();
